<template>
  <div class="__detail">
    <VueJsonPretty
      :data='data'
      :deep='deep'
      :showLength='true'
      :showLine='true'
    />
  </div>
</template>

<script>

import VueJsonPretty from 'vue-json-pretty'

import 'vue-json-pretty/lib/styles.css'

export default {
  name: 'Panel',
  components: {VueJsonPretty},
  props: {
    data: {
      required: true,
      type: Object,
    },
    deep: {
      type: Number,
      default: 2
    }
  }
}
</script>

<style scoped>
.__detail * {
  background: #1D1D1D;
  color: #FFF;
  padding: 16px;
  border-radius: 4px;
}
</style>
